module.exports = __webpack_public_path__ + "static/media/Pansage_gaussian2.3f4330fc.png";